const ReferenceRecordSchemaPlugin = {
  name: 'Reference record schema plugin',
  schema: {
    'aha-reference': {
      isVoid: true,
      isInline: true,
    },
  },
};
export default ReferenceRecordSchemaPlugin;
